import talkr from "../assets/portfolio/talkr.png"
import ecommerce from "../assets/portfolio/ecommerce.png"
import vidtube from "../assets/portfolio/vidtube.png"

const projectDetails = [
    {
        id:1,
        name:"TALKR",
        src:talkr,
        codeWebsite: "https://github.com/ankit3954/chat-app-backend",
        demoSite: "https://deft-flan-9107db.netlify.app/",
        description: "As name suggests it is chatting web application. In this web app, users can send text as well as emojis once registered."
    },

    {
        id:2,
        name:"VIDTUBE",
        src:vidtube,
        codeWebsite: "https://github.com/ankit3954/vidtube-app",
        demoSite: "https://vocal-hummingbird-f96da5.netlify.app/",
        description: "It is web app which can be used to watch all YouTube videos. User can able to see number of subscribers, likes and views of videos."
    },

    {
        id:3,
        name:"E-COMMERCE APP",
        src:ecommerce,
        codeWebsite: "https://github.com/ankit3954/ecommerce-web-app",
        demoSite: "https://monumental-meringue-453b11.netlify.app/",
        description: "It is online shopping web app. User can use Google accounts to sign in."
    },
];

export default projectDetails;